export class Modal {
  private element: HTMLButtonElement;
  private dialog: HTMLDialogElement | null = null;
  private dialogClose: HTMLButtonElement | null = null;

  constructor(element: HTMLButtonElement) {
    if (!!element) {
      this.element = element;
      this.dialog = document.querySelector(`#${this.element.dataset.dialog}`);
      this.dialogClose = this.dialog
        ? this.dialog.querySelector(".closeDialog")
        : null;
      this.init();
    }
  }

  private init() {
    this.handleEvents();
    this.handleUnsupportedBrowsersBackdropClose();
  }

  private handleEvents() {
    this.element.addEventListener("click", () => {
      /* Open dialog */
      this.dialog?.showModal();
    });

    /* Close dialog */
    this.dialogClose?.addEventListener("click", () => this.handleDialogClose());

    /* Close dialog when clicking on backdrop */
    // this.dialog?.addEventListener("click", (event) => {
    //   if (event.target === this.dialog) {
    //     this.handleDialogClose();
    //   }
    // });
  }

  private handleUnsupportedBrowsersBackdropClose() {
    // Code for browsers that don't support interpolate-size
    if (!CSS.supports("interpolate-size", "allow-keywords")) {
      /* Close dialog when clicking on backdrop for unsupported browsers */
      this.dialog?.addEventListener("click", (event) => {
        if (this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          const x = event.clientX;
          const y = event.clientY;

          // Check if click is outside the dialog bounds (on backdrop)
          if (
            x < rect.left ||
            x > rect.right ||
            y < rect.top ||
            y > rect.bottom
          ) {
            this.handleDialogClose();
          }
        }
      });
    }
  }

  private handleDialogClose() {
    if (CSS.supports("interpolate-size", "allow-keywords")) {
      this.dialog?.close();
    } else {
      this.dialog?.classList.add("dialog--closing");
      const transitionDuration = getComputedStyle(document.documentElement)
        .getPropertyValue("--transition-duration")
        .trim();
      const transitionDurationMs =
        parseFloat(transitionDuration.replace("s", "")) * 1000;
      setTimeout(() => {
        this.dialog?.classList.remove("dialog--closing");
        this.dialog?.close();
      }, transitionDurationMs);
    }
  }
}

export default function modalInit() {
  const modals = document.querySelectorAll(
    "button[data-dialog]",
  ) as NodeListOf<HTMLButtonElement>;
  for (let i = 0; i < modals.length; i++) {
    new Modal(modals[i]);
  }
}
